/**
 * Portal chrome dimensions.
 * CSS tokens in portal-theme.css use rem equivalents of these values
 * (--y-app-bar-height: 4.5rem, --y-drawer-width: 16.25rem, --y-drawer-rail-width: 4.25rem).
 * Vuetify :width / :height props expect CSS pixel numbers; Windows DPI
 * scales those physical pixels — do not also shrink rem via vw.
 */
export const APP_BAR_HEIGHT = 72
export const MAIN_PADDING = 16
export const DRAWER_WIDTH = 260
export const DRAWER_RAIL_WIDTH = 68
export const SIDEBAR_RAIL_STORAGE_KEY = 'yandle-sidebar-rail'
